import { transport } from 'config/transport';

export function callApiExportBienLai(congDoanId, classId, month, studentIds, type, subjectIds = []) {
    return transport.get(`/mamnon/${congDoanId}/thuhocsinh/${classId}/phieuthu/exportBienLaiPdf`, {
        params: { month, studentIds, type, subjectIds: subjectIds.join(',') },
        responseType: 'blob',
    });
}
